export var preparePublishedAnnouncements = function preparePublishedAnnouncements(publishedAnnouncementsCount) {
  var substring;
  if (!publishedAnnouncementsCount) {
    return;
  }
  if (publishedAnnouncementsCount === 1) {
    substring = 'активное объявление';
  } else if (publishedAnnouncementsCount > 1 && publishedAnnouncementsCount < 5) {
    substring = 'активных объявления';
  } else {
    substring = 'активных объявлений';
  }
  return "\u0432 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0435 ".concat(publishedAnnouncementsCount, " ").concat(substring);
};